import { POST } from '@api/http';

export const RestrictionDetails = {
    search: (spec) => POST('next/Restriction/GetRestrictionDetails', spec),
};
